import { LOGO, LOGO_DARK } from "@/data/content";

export const Logo = ({ className = "" }) => (
  <>
    <img src={LOGO} alt="Ilmora Academy" className={`${className} w-auto object-contain dark:hidden`} />
    <img src={LOGO_DARK} alt="Ilmora Academy" className={`${className} w-auto object-contain hidden dark:block`} />
  </>
);
